"use client"
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { Button } from '@material-tailwind/react';
import React, { useState } from 'react';
import { BuyNow, emailNotify, fbConversionAPI } from '@/API/response';
import { errorNotify, successNotify } from '../Toast';
import { ToastContainer } from "react-toastify";
import { useDispatch, } from 'react-redux';
import { clearCartItems } from '@/GlobalRedux/Slices/allCartItems';
import { useRouter } from 'next/navigation';
const CheckOutForm = ({ shippingPrice, setShippingPrice }) => {
  const [showModal, setShowModal] = useState(false);
  const [IsSubmit, setIsSubmit] = useState(false);
  const router = useRouter()
  const dispatch = useDispatch()
  const initialValues = {
    customerName: '',
    customerEmail: '',
    customerPhone: '',
    shippingAddress: '',
    shippingCity: '',
    shippingZipCode: '',
    shippingCountry: 'Pakistan',
    address: '',
    shippingMethod: 'Standard',
  };

  const validationSchema = Yup.object({
    customerName: Yup.string().required('Customer Name is required'),
    customerEmail: Yup.string().email('Invalid email format').required('Email is required'),
    customerPhone: Yup.string().matches(/^[0-9]+$/, 'Must be a number')
      .min(10, 'Phone number must be at least 10 digits')
      .max(13, 'Phone number must not exceed 13 digits')
      .required('Phone Number is required'),
    shippingAddress: Yup.string().required('Address is required'),
    // address: Yup.string().required('Address is required'),
    shippingCity: Yup.string().required('City is required'),
    // shippingZipCode: Yup.string().matches(/^[0-9]+$/, 'Must be a number').required('Zip Code is required'),
    shippingCountry: Yup.string().required('Country is required')
  });


  const handleSubmit = async (values, { resetForm }) => {
    const mappedValues = {
      ...values,
      shippingPrice: shippingPrice,
      shippingDetails: {
        address: values.address,
        city: values.shippingCity,
        zipCode: values.shippingZipCode,
        country: values.shippingCountry,
      },
    };
    try {
      setIsSubmit(true)
      const response = await BuyNow(mappedValues, "cart/buyNow")
      if (response.status) {
        const { orderId, totalAmount, customerEmail, items } = response.data.order;
        // email notify API         
        try {
          const res = await emailNotify({
            orderId: orderId,
            totalAmount: totalAmount,
            email: customerEmail,
            item: items
          }, "sendOrderConfirmation")

        } catch (error) {
          console.log(error)
        }
        // facebook API conversion
        const data = {
          eventName: "purchase",
          eventData: {
            details: {
              orderId,
              totalAmount,
              customerEmail,
              items
            }
          },
        }
        try {
          const res = await fbConversionAPI(data, "fb-conversion")

        } catch (error) {
          console.log(error)
        }
        // console.log("items",items)
        // // Track the purchase event using Meta Pixel
        // fbq('track', 'Purchase', {
        //   content_ids: items?.map(item => item.id), // Product IDs from the catalog
        //   value: totalAmount, // Total order amount
        //   currency: "PKR", // Set currency
        //   content_type: "product", // Defines the type
        //   contents: items.map(item => ({
        //     id: item?.productId?._id,
        //     quantity: item.quantity,
        //     item_price: item?.productId?.price
        //   })) // Detailed catalog data
        // });
        dispatch(clearCartItems())
        successNotify(response?.data?.message)
        resetForm()
        setShowModal(true);
        setIsSubmit(false)
        // router.push("/")
      } else {
        errorNotify(response?.error)
        setIsSubmit(false)
      }
    } catch (error) {
      console.log("error", error)
      setIsSubmit(false)

    }
  };
  // zip code ,address optional , 
  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ errors, touched, setFieldValue, values }) => (
          <Form className="grid gap-4">
            <div className="relative mb-4">
              <Field
                name="customerName"
                type="text"
                placeholder="Customer Name"
                className={`block w-full p-2 border-b-2 ${errors.customerName && touched.customerName ? 'border-red-500' : 'border-gray-300'}`}
              />
              <ErrorMessage name="customerName" component="div" className="text-red-500 text-sm mt-1" />
            </div>

            <div className="relative mb-4">
              <Field
                name="customerEmail"
                type="email"
                placeholder="Email"
                className={`block w-full p-2 border-b-2 ${errors.customerEmail && touched.customerEmail ? 'border-red-500' : 'border-gray-300'}`}
              />
              <ErrorMessage name="customerEmail" component="div" className="text-red-500 text-sm mt-1" />
            </div>

            <div className="relative mb-4">
              <Field
                name="customerPhone"
                type="number"
                placeholder="Phone Number"
                className={`block w-full p-2 border-b-2 ${errors.customerPhone && touched.customerPhone ? 'border-red-500' : 'border-gray-300'}`}
              />
              <ErrorMessage name="customerPhone" component="div" className="text-red-500 text-sm mt-1" />
            </div>

            <div className="relative mb-4">
              <Field
                name="shippingAddress"
                type="text"
                placeholder="Shipping Address"
                className={`block w-full p-2 border-b-2 ${errors.shippingAddress && touched.shippingAddress ? 'border-red-500' : 'border-gray-300'}`}
              />
              <ErrorMessage name="shippingAddress" component="div" className="text-red-500 text-sm mt-1" />
            </div>
            <div className="relative mb-4">
              <Field
                name="address"
                type="text"
                placeholder="Appartment , Suits, near by location or Famous location "
                className={`block w-full p-2 border-b-2 ${errors.address && touched.address ? 'border-red-500' : 'border-gray-300'}`}
              />
              <ErrorMessage name="address" component="div" className="text-red-500 text-sm mt-1" />
            </div>

            <div className="relative mb-4">
              <Field
                name="shippingCity"
                type="text"
                placeholder="City"
                className={`block w-full p-2 border-b-2 ${errors.shippingCity && touched.shippingCity ? 'border-red-500' : 'border-gray-300'}`}
              />
              <ErrorMessage name="shippingCity" component="div" className="text-red-500 text-sm mt-1" />
            </div>

            <div className="relative mb-4">
              <Field
                name="shippingZipCode"
                type="text"
                placeholder="Zip Code"
                className={`block w-full p-2 border-b-2 ${errors.shippingZipCode && touched.shippingZipCode ? 'border-red-500' : 'border-gray-300'}`}
              />
              <ErrorMessage name="shippingZipCode" component="div" className="text-red-500 text-sm mt-1" />
            </div>

            <div className="relative mb-4">
              <Field
                name="shippingCountry"
                readOnly
                type="text"
                placeholder="Country"
                className={`block w-full p-2 border-b-2 ${errors.shippingCountry && touched.shippingCountry ? 'border-red-500' : 'border-gray-300'}`}
              />
              <ErrorMessage name="shippingCountry" component="div" className="text-red-500 text-sm mt-1" />
            </div>

            <div className="relative mb-4">
              <Field
                name="shippingMethod"
                as="select"
                onChange={(e) => {
                  const selectedMethod = e.target.value;
                  setFieldValue('shippingMethod', selectedMethod);
                  setShippingPrice(selectedMethod === 'Standard' ? 200 : 350);
                }}
                className="block w-full p-2 border-b-2 border-gray-300"
              >
                <option value="Standard">Standard 200 PKR</option>
                <option value="Express">Express 350 PKR</option>
              </Field>
            </div>
            <Button type="submit" className="w-full text-pureWhite">
              {IsSubmit ? "Loading..." : "Submit"}
            </Button>
            <ToastContainer />
          </Form>
        )}
      </Formik>
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-50 p-4">
          <div className="bg-white px-4 py-6 sm:p-6 rounded-lg shadow-lg text-center  sm:max-w-lg w-full">
            <h2 className="text-lg sm:text-xl font-semibold mb-4">
              🎉 Thank You for Your Order!
            </h2>

            {/* Order Confirmation Message */}
            <p className="text-gray-600 text-left text-sm sm:text-base leading-relaxed">
              Thank you for choosing <strong>Mystical Fragrance!</strong> <br /><br />

              <strong>Important Instructions:</strong> <br />
              ✔ Use your <strong>Order Number</strong> as the payment reference. <br />
              ✔ As per company policy, a <strong>200 Rs delivery charge</strong> is required after placing an order.
              Your order will be processed within <strong>1-2 business days</strong> after payment confirmation. <br />
              ✔ Send the transaction receipt to <a href="mailto:mysticalfragranc@gmail.com" className="text-blue-500 underline">mysticalfragranc@gmail.com</a>
              or WhatsApp at <a href="https://wa.me/923010212794" className="text-blue-500 underline">03010212794</a> for verification. <br /><br />

              <strong>Bank Payment Details:</strong> <br />
              🔹 <strong>Bank Name:</strong> Meezan Bank Limited <br />
              🔹 <strong>Account Title:</strong> ABDUL RAFAY <br />
              🔹 <strong>Account Number:</strong> 01280107771300 <br />
              🔹 <strong>IBAN:</strong> PK77MEZN0001280107771300 <br /><br />

              If you face any issues, feel free to contact us at
              <a href="mailto:mysticalfragranc@gmail.com" className="text-blue-500 underline"> mysticalfragranc@gmail.com</a>.
            </p>

            <button
              onClick={() => {
                setShowModal(false);
                router.push("/"); // Redirect to home or another page
              }}
              className="mt-6 px-4 py-2  bg-blue-500 text-pureWhite rounded-lg hover:bg-blue-600  w-full"
            >
              OK
            </button>
          </div>
        </div>

      )}
    </>

  );
};

export default CheckOutForm;
